import React, { Children, cloneElement, memo, useCallback } from 'react';
import classNames from 'classnames';

import style from './style.module.css';

const ButtonsGroupComponent = ({ children, border = true, size, shape, value, onChange }) => {
  const handleClick = useCallback(
    buttonValue => {
      onChange?.(buttonValue);
    },
    [onChange],
  );

  return (
    <div className={classNames(style.host, { [style.border]: border })} role="group">
      {Children.map(children, child =>
        cloneElement(child, {
          isActive: child.props.value === value,
          onSelect: handleClick,
          shape,
          size,
        }),
      )}
    </div>
  );
};

export const ButtonsGroup = memo(ButtonsGroupComponent);
